// TODO: delete when new customize UI enabled for everyone
import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { inject, observer } from 'mobx-react';
import b from 'b_';
import CustomPagesStore, { CustomPageEditStore } from '../../stores/CustomPagesStore';
import SnackStore from '../../stores/SnackStore';
import PagePreview from '../PagePreview/PagePreview';
import Button from '../Button';
import {
    ConsoleCard,
    ConsoleCardHeader,
    ConsoleCheckbox,
    FuseConsoleField,
} from '../ConsoleFragments';
import UDSpinner from '../UD/Fragments/UDSpinner';
import { ObservableTextfield } from '../Textfield';
import EditCustomPageContent from './EditCustomPageContent';
import FuseReadOnlySwitch from '../FuseControls/FuseReadOnlySwitch';
import './EditCustomPage.css';

const block = b.lock('EditCustomPage');

class EditCustomPage extends Component {
    static propTypes = {
        title: PropTypes.node.isRequired,
        enableInfo: PropTypes.node.isRequired,
        pageComponent: PropTypes.func.isRequired,
        store: CustomPageEditStore.PropType.isRequired,
        customPages: CustomPagesStore.PropType.isRequired,
        snack: SnackStore.PropType.isRequired,
        readOnly: PropTypes.bool,
    };

    save = () => {
        this.props.customPages.save(this.props.store)
            .then(() => this.props.snack.showSuccess(
                `Changes to ${this.props.title} page have been saved.`))
            .catch((error) => error && this.props.snack.showError(
                `Failed to save block page configuration. ${error.message}`));
    };

    renderLogoInput() {
        const { store } = this.props;
        return <form className={block('LogoForm')}>
            <input
                className={block('LogoInput')}
                type="file"
                accept="image/png, image/jpeg"
                ref={store.fileInputRef}
                onChange={store.onFileInputChange}
                key={store.fileInputKey}
            />
            {store.logoName ? <Fragment>
                <Button
                    className={block('LogoInputButton')}
                    red
                    raised
                    onClick={() => store.clearLogo(true)}
                >Remove Image</Button>
                <div className={block('LogoFileName')}>
                    {store.logoName}
                </div>
            </Fragment> : <Fragment>
                <Button
                    className={block('LogoInputButton')}
                    primary
                    raised
                    onClick={() => store.openFileInput()}
                >Select Image</Button>
                <div className={block('LogoInputLabel', { error: store.logoMimeError.isTrue })}>
                    Only JPG and PNG file types supported.
                </div>
            </Fragment>}
        </form>;
    }

    renderCardBody = () => {
        const { enableInfo, store, readOnly } = this.props;
        return <div className={block('Options')}>
            <div className={block('OptionsRow')}>
                <FuseReadOnlySwitch
                    header="Block Page Contents"
                    className={block('ContentsCheckbox')}
                    tooltip={enableInfo}
                    readOnly={readOnly}
                    store={store.enabledStore}
                    label={store.enabledStore.value ? 'Custom' : 'Default'}
                    readOnlyValue={store.enabledStore.value ?
                        <Fragment><b>Custom</b> - use custom content</Fragment> :
                        <Fragment><b>Default</b> - use the default content</Fragment>}
                />
                {store.enabledStore.isTrue && !readOnly ? <FuseConsoleField
                    className={block('Logo')}
                    name="Company Logo"
                    info="Image will be resized to a maximum height of 150 pixels.
                          Only JPG and PNG file types are supported."
                >{this.renderLogoInput()}</FuseConsoleField> : null}
            </div>
            {store.enabledStore.isTrue && !readOnly ? <Fragment>
                <div className={block('OptionsRow')}>
                    <ObservableTextfield
                        className={block('Headline')}
                        label="Headline"
                        store={store.headlineStore}
                    />
                    <ConsoleCheckbox
                        className={block('HeadlineIcon')}
                        flagStore={store.headlineIconStore}
                    >Display headline icon</ConsoleCheckbox>
                    <ConsoleCheckbox
                        className={block('Background')}
                        flagStore={store.backgroundStore}
                    >Display background image</ConsoleCheckbox>
                </div>
                <EditCustomPageContent store={store.editCustomPageContent} />
                <div className={block('Disclaimer')}>
                    Customized block pages will not be translated to other languages.
                </div>
            </Fragment> : null}
        </div>;
    };

    render() {
        const { readOnly, title, store, pageComponent, customPages } = this.props;

        return <ConsoleCard key={title}>
            <ConsoleCardHeader title={title}>
                {readOnly ? null : <Button
                    className={block('Save')}
                    raised
                    primary
                    disabled={!store.hasChanged()}
                    loading={store.saveStatus.isLoading}
                    onClick={this.save}
                >Save</Button>}
            </ConsoleCardHeader>
            {customPages.loadStatus.isLoading ? <div className={block('SpinnerWrapper')}>
                <UDSpinner
                    className={block('Spinner')}
                    type="small"
                />
            </div> : null}
            {customPages.loadStatus.result ? <Fragment>
                {this.renderCardBody()}
            </Fragment> : null}
            <PagePreview
                pageComponent={pageComponent}
                previewToggle={store.previewToggle}
                headline={store.enabledStore.isTrue ? 'Custom Block Page' : 'Default Block Page'}
                pageProps={store.enabledStore.isTrue ? store.getContent() : {}}
            />
        </ConsoleCard>;
    }
}

export default inject('customPages', 'snack')(observer(EditCustomPage));
